module.exports = __webpack_public_path__ + "static/assets/1b72f27ddfd09fac8f7f9384e8a5f27f.svg";